import { defineMessages } from 'react-intl';

export default defineMessages({
  adult: {
    id: 'booking.payment.summary.adults',
    defaultMessage: '${value} x {amount, number} {amount, plural, one {adult} other {adults}}', // eslint-disable-line
  },
  child: {
    id: 'booking.payment.summary.children',
    defaultMessage: '${value} x {amount, number} {amount, plural, one {child} other {children}}', // eslint-disable-line
  },
  infant: {
    id: 'booking.payment.summary.infants',
    defaultMessage: '${value} x {amount, number} {amount, plural, one {infant} other {infants}}', // eslint-disable-line
  },
  group: {
    id: 'booking.payment.summary.group',
    defaultMessage: 'group ticket', // eslint-disable-line
  },
  discount: {
    id: 'booking.payment.summary.discount',
    defaultMessage: 'discount ({value}% off)', // eslint-disable-line
  },
});
